function handleProgressBarState( eName ) {
    
    let scrollPosition = window.scrollY;
    const progressBar = document.querySelector("#sk-progress-bar");
    const processContent = document.querySelector(".sk-process-content");
    const app = document.querySelector(".sk-app");

    setTimeout(() => {
        if ( progressBar ) {
            //const isFixed = progressBar.dataset.fixed;
            if ( (scrollPosition > 99) )  {
                progressBar.dataset.fixed = "true";
                app.dataset.progressBarFixed = "true";
            } else if( (scrollPosition < 99) ) {
                progressBar.dataset.fixed = "false";
                app.dataset.progressBarFixed = "false";
                processContent.style.paddingTop = 0;
            }
            ( eName === 'resize' && scrollPosition > 99 ) && window.scrollTo(0, (scrollPosition + 50));
        }
    }, 200);
};

export { handleProgressBarState };